import React, { Component } from "react";
import PropTypes from "prop-types";
import UnauthorizedRoute from "./UnauthorizedRoute";
import { connect } from "react-redux";

class UnauthorizedRouteContainer extends Component {
  static propTypes = {
    component: PropTypes.oneOfType([ PropTypes.node, PropTypes.func, PropTypes.element, PropTypes.any ]).isRequired,
  };

  render() {
    const { component, userRoles, ...rest } = this.props;

    return (
      <UnauthorizedRoute component={component}
                         userRoles={userRoles}
                         {...rest}
      />
    );
  }
}

export default connect(({ authorization }) => ({
  userRoles: authorization?.roles,
}))(UnauthorizedRouteContainer);
